import { CompanyCollectorCommissionTariffRepository } from '@domain/company-collector-commission-tariff/repositories/company-collector-commission-tariff.repository';
import { CompanyCollectorCommissionTariffRepositoryService } from '../repositories/company-collector-commission-tariff-repository.service';

export const CompanyCollectorCommissionTariffProvider = [
  {
    provide: CompanyCollectorCommissionTariffRepository,
    useClass: CompanyCollectorCommissionTariffRepositoryService,
  },
];
